import colors from '../../../../../lib/colors'

import { button } from '../../../../../component/component'

export default function(o,c){

  var click = function(e){
    o.loopStart = o.video.currentTime
    o.looping = !o.looping
    if(o.looping){
      div.setColor(colors.yellow.s_600)
    } else {
      div.setColor(colors.white)    
    }
  }

  if(o.looping){
    var color = colors.yellow.s_600
  } else {
    var color = colors.white
  }

  var div =
    button(null,'fi-loop',false,color)
    .click(click)

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/buttons/loop/loop.js